import { render, staticRenderFns } from "./VideoCardsItem.vue?vue&type=template&id=1e0756cc&scoped=true"
import script from "./VideoCardsItem.vue?vue&type=script&lang=js"
export * from "./VideoCardsItem.vue?vue&type=script&lang=js"
import style0 from "./VideoCardsItem.vue?vue&type=style&index=0&id=1e0756cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0756cc",
  null
  
)

export default component.exports